import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import Lottie from 'react-lottie';
import * as animationData from '../../../lotties/streak_check_orange.json';
const CHECK_SOUND_PATH = '/assets/audio/shine-8.mp3';
const options = {
    loop: false,
    animationData: animationData,
};
export const StreakTodayCheckIcon = ({ classObject, delayMs = 0 }) => {
    const [isReady, setIsReady] = React.useState(delayMs === 0);
    React.useEffect(() => {
        let timeoutId = null;
        let audio = null;
        const playSound = () => {
            if (typeof Audio === 'undefined')
                return;
            audio = new Audio(CHECK_SOUND_PATH);
            audio.preload = 'auto';
            const playResult = audio.play();
            if (playResult && typeof playResult.catch === 'function') {
                playResult.catch(() => null);
            }
        };
        setIsReady(delayMs === 0);
        if (delayMs > 0) {
            timeoutId = setTimeout(() => {
                setIsReady(true);
                playSound();
            }, delayMs);
        }
        else {
            playSound();
        }
        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            if (audio) {
                audio.pause();
                audio.src = '';
            }
        };
    }, [delayMs]);
    if (!isReady) {
        return null;
    }
    return (React.createElement("div", { className: css(styles.icon, classObject) },
        React.createElement(Lottie, { options: options })));
};
const styles = StyleSheet.create({
    icon: {
        width: 34,
        height: 34,
    },
});
